// tzn_ Layer: Sticky Add-to-Cart (Mobile)
// Blendet den nativen "product-quick-add"-Balken aus, solange der reguläre
// ATC-Button (Buy-Box im Produktformular) im Viewport sichtbar ist, und wieder
// ein, sobald er nicht mehr sichtbar ist (egal ob noch nicht erreicht oder schon
// vorbeigescrollt). Ergänzt die per CSS erzwungene Dauer-Sichtbarkeit in
// tzn_pdp.css -- dort übersteuert die Klasse "tzn-static-atc-visible" per
// höherer Selektor-Spezifität wieder auf ausgeblendet.
(function () {
  if (window.matchMedia('(min-width: 700px)').matches) {
    return;
  }

  var stickyBar = document.querySelector('.product-quick-add');
  if (!stickyBar) {
    return;
  }

  var staticForm = document.getElementById(stickyBar.getAttribute('form'));
  if (!staticForm) {
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      stickyBar.classList.toggle('tzn-static-atc-visible', entry.isIntersecting);
    });
  });

  observer.observe(staticForm);
})();
